// pothos cabinet identity — /api/getCabinetRole. Reports the caller's own
// team_role and whether they may preview other role views (QA-revision
// owner). The island uses role to pick its tab set; a qa role sees only
// QA / Лимиты / Обзор.
import { z } from 'zod';

export const PothosCabinetRoleResSchema = z.object({
  role: z.string(),
  can_preview_roles: z.boolean(),
  /** Владелец ревизии (QA_REVISION_EMAIL): ему одному видна вкладка «Тикеты». */
  is_revision_owner: z.boolean().default(false),
});
export type PothosCabinetRoleRes = z.infer<typeof PothosCabinetRoleResSchema>;

// ─── Тикеты дизайнеров (саппорт-поверхность владельца ревизии) ───────────────
// Строка тикета + «исходник»: где лежит SVG-мастер проблемного пака.
// source_url — относительный путь на публичный /api/getDesignerSVG.
export const PothosTicketSchema = z.object({
  id: z.string(),
  locale: z.string(),
  merchant: z.string(),
  participant_id: z.string().default(''),
  description: z.string(),
  plugin_step: z.string().default(''),
  last_action: z.string().default(''),
  plugin_version: z.string().default(''),
  status: z.string(),
  created_at: z.string().default(''),
  resolved_at: z.string().default(''),
  resolution_notes: z.string().default(''),
  reporter_email: z.string().default(''),
  source_table: z.string().default(''),
  source_r2_binding: z.string().default(''),
  source_r2_key: z.string().default(''),
  source_url: z.string().default(''),
  master_json_r2_key: z.string().default(''),
  master_json_url: z.string().default(''),
});
export type PothosTicket = z.infer<typeof PothosTicketSchema>;

export const PothosManagerTicketsResSchema = z.object({
  open: z.array(PothosTicketSchema).default([]),
  recent_resolved: z.array(PothosTicketSchema).default([]),
});
export type PothosManagerTicketsRes = z.infer<typeof PothosManagerTicketsResSchema>;
